module.exports = __webpack_public_path__ + "img/Shopee2.d619c217.svg";